<template>
  <div>
    <div class="personal_header">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我的文章" name="first"></el-tab-pane>
        <el-tab-pane label="我的视频" name="second"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 我的文章 -->
    <div class="personal_news" v-if="activeName == 'first'">
      <div v-if="isNews">
        <div class="personal_news_content" v-for="(item, index) in newsdetail_list" :key="index">
          <div class="personal_news_content_title"  @click="getDetail(item.news_id)">{{item.title}}</div>
            <div class="personal_news_content_bottom">
              <div class="personal_author">{{item.author}}</div>
              <div class="personal_create_time">{{item.create_time}}</div>
              <img :src="play" class="personal_play1" />
              <div class="personal_news_content_font">{{item.view}}</div>
              <img :src="icon" class="personal_icon1" />
              <div class="personal_news_content_font">38</div>
            </div>
        </div>
      </div>

      <div class="personal_no" v-else>
        <div class="personal_no_img">
          <img :src="gantan" alt />
        </div>
        <div class="personal_no_font">空空如也，快去找些感兴趣的内容吧！</div>
      </div>
    </div>

    <!-- 我的视频 -->
    <div class="personal_videos" v-if="activeName == 'second'">
      <div v-if="isVideo">
        <div class="personal_videos_content" v-for="(item, index) in videosdetail_list" :key="index">
          <div class="personal_videos_header" @click="getVideoDetail(item.video_id)">
            <img :src="item.cover" alt="">
          </div>
          <div class="personal_videos_title">{{item.title}}</div>
          <div class="personal_videos_bottom">
            <img :src="play" class="play" />
            <div >{{item.view}}</div>
            <img :src="icon" class="icon" />
            <div >{{item.comment}}</div>
          </div>
        </div>
      </div>
      <div class="personal_no" v-else>
        <div class="personal_no_img">
          <img :src="gantan" alt />
        </div>
        <div class="personal_no_font">空空如也，快去找些感兴趣的内容吧！</div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsCollect, videoCollect } from "../../api/api";
export default {
  name: "Collect",
  data() {
    return {
      activeName: "first",
      isNews: "",
      isVideo: "",
      gantan: "./static/img/!.png",
      play: "./static/img/play.png",
      icon: "./static/img/icon.png",
      newsdetail_list: [],
      videosdetail_list: []
    };
  },
  mounted() {
    this.$store.commit("setNavLeft", 2);
    newsCollect({
      ticket: localStorage.getItem('ticket')
    }).then(res => {
      if(res.data){
        this.isNews = true
      }else{
        this.isNews = false
      }
      //console.log(res.data)
      this.newsdetail_list = res.data;
    });
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      if(tab.name == "first"){
        newsCollect({
          ticket: this.$store.state.ticket
        }).then(res => {
          if(res.data){
            this.isNews = true
          }else{
            this.isNews = false
          }
          this.newsdetail_list = res.data;
        });
        
      }
      if(tab.name == "second"){
        videoCollect({
          ticket: this.$store.state.ticket
        }).then(res => {
          if(res.data){
              this.isVideo = true
            }else{
              this.isVideo = false
            }
          this.videosdetail_list = res.data;
        });
      }
    },
    getDetail(id){
      this.$router.push('/NewsDetail/'+ id)
    },

    getVideoDetail(id){
      this.$router.push('/videoDetail/'+ id)
    }
  }
};
</script>

<style>
.personal_header {
  width: 974px;
}
.personal_header .el-tabs__item {
  font-size: 26px;
  margin-bottom: 10px;
  color: #636363;
}
.personal_header .el-tabs__item.is-active {
  color: #55b233;
}
.personal_header .el-tabs__active-bar {
  background-color: #55b233;
}
.personal_header .el-tabs__item:hover {
  color: #55b233 !important;
}
.personal_no {
  display: flex;
  padding-top: 120px;
  margin-left: 157px;
  height: 590px;
}
.personal_no_img {
  width: 69px;
  height: 69px;
}
.personal_no_img img {
  width: 100%;
  height: 100%;
}
.personal_no_font {
  height: 69px;
  line-height: 69px;
  margin-left: 30px;
  font-size: 26px;
  color: #c4c4c4;
}
.personal_news {
  /* margin-top: 20px; */
  width: 974px;
  overflow:hidden;
  padding-bottom: 50px;
  background: #ffffff;
}
.personal_news_content {
  width: 900px;
  border-bottom: 1px solid #b5b5b5;
  padding: 20px 0;
  padding-left: 10px;
  margin-left: 31px;
}
.personal_news_content_title {
  height: 30px;
  line-height: 29px;
  font-size: 28px;
  color: #000000;
  margin-bottom: 25px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 17px;
  cursor: pointer;
}
.personal_news_content_bottom{
  height: 17px;
  line-height: 17px;
  font-size: 16px;
  color: #000000;
  display: flex;
  margin-bottom: 10px;
}
.personal_create_time{
  margin-left: 38px;
}
.personal_play1{
  width: 20px;
  height: 20px;
  margin-left: 68px;
}
.personal_news_content_font{
  margin-left: 5px;
}
.personal_icon1{
  width: 20px;
  height: 20px;
  margin-left: 27px;
}
.personal_news_content_font{
  margin-left: 5px;
}
.personal_videos{
  width: 1000px;
  overflow:hidden;
  padding-right: 50px;
  padding-bottom: 50px;
  background: #ffffff;
}
.personal_videos_content{
  width: 44%;
  height: 300px;
  float: left;
  margin-left: 50px;
  margin-bottom: 30px;
}
.personal_videos_header{
  width: 100%;
  height: 210px;
  margin: 0 auto;
  margin-top: 50px;
  cursor: pointer;
}
.personal_videos_header img{
  width: 100%;
  height: 100%;
}
.personal_videos_title{
  margin-top: 22px;
  height: 19px;
  line-height: 19px;
  font-size: 18px;
  color: #000000;
  overflow: hidden;
}
.personal_videos_bottom{
  display: flex;
  margin-top: 20px;
  font-size: 14px;
  margin-bottom: 50px;
}
.personal_videos_bottom .play{
  width: 19px;
  height: 19px;
  margin-right: 8px;
  /* margin-top: 5px; */
}
.personal_videos_bottom .icon{
  width: 20px;
  height: 19px;
  margin-right: 8px;
  /* margin-top: 5px; */
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/my/Collect.vue